import type { LucideIcon } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { SwitcherActiveFlag } from './SwitcherActiveFlag';
import { cn } from '@/lib/utils';

interface SwitcherItemProps {
  name: string;
  isActive: boolean;
  icon: LucideIcon;
}

export function SwitcherItem({
  name,
  isActive,
  icon: Icon,
}: SwitcherItemProps) {
  return (
    <div className="flex items-center gap-2 w-full">
      <div
        className={cn(
          'flex h-6 w-6 items-center justify-center rounded-full flex-shrink-0',
          isActive
            ? 'bg-accent-foreground/20 text-accent-foreground'
            : 'bg-muted'
        )}
      >
        <Icon className="h-3.5 w-3.5" />
      </div>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className={cn(
              'text-sm truncate flex-1 min-w-0',
              isActive && 'text-accent-foreground'
            )}
          >
            {name}
          </span>
        </TooltipTrigger>
        <TooltipContent>{name}</TooltipContent>
      </Tooltip>
      {isActive && <SwitcherActiveFlag />}
    </div>
  );
}
